import { constants, BANNER_TYPE } from '../../Constants/constants';
import { BannerCreate } from "../Banner/BannerCreate";

export const TicketBannerCreate = () => {
  return <BannerCreate newPath={constants.PATH.TICKET.TICKET_BANNER_LIST}
    redirectPath={constants.PATH.TICKET.TICKET_BANNER}
    bannerType={BANNER_TYPE.TICKET}
    tab={0} />
};